import { motion } from "framer-motion";

const SHOTS = [
  {
    src: "https://images.unsplash.com/photo-1598935440744-79c688cec3f7?q=80&w=1200&auto=format&fit=crop",
    alt: "Sonoran desert landscape under a wide evening sky",
    label: "Field Note 01",
    caption: "Sonoran miles, last light",
    offset: false,
    testid: "photo-story-desert",
  },
  {
    src: "https://images.unsplash.com/photo-1589390948789-416cb1c195f0?q=80&w=1200&auto=format&fit=crop",
    alt: "Highway stretching through open desert country",
    label: "Field Note 02",
    caption: "The corridor, golden hour",
    offset: true,
    testid: "photo-story-highway",
  },
  {
    src: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1200&auto=format&fit=crop",
    alt: "Freight truck running a desert highway through red rock country",
    label: "Field Note 03",
    caption: "Statewide routes, on request",
    offset: false,
    testid: "photo-story-truck",
  },
];

export const PhotoStory = () => (
  <section data-testid="photo-story-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(circle at 80% 20%, rgba(232,157,75,0.08) 0%, transparent 55%)" }}
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="font-mono text-xs tracking-[0.3em] uppercase text-[#C85A32] mb-14 flex items-center gap-3"
      >
        <span className="w-10 h-px bg-[#C85A32]" />
        Dispatch // Field Notes
      </motion.p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-start">
        {SHOTS.map((shot, i) => (
          <motion.figure
            key={shot.label}
            data-testid={shot.testid}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className={`group ${shot.offset ? "md:mt-20" : ""}`}
          >
            <div className="overflow-hidden rounded-xl border border-[#C85A32]/25">
              <img
                src={shot.src}
                alt={shot.alt}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover transition-[transform,filter] duration-700 group-hover:scale-105"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline justify-between gap-4">
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#E89D4B]">{shot.label}</span>
              <span className="font-display italic text-lg text-[#E6DACB]/80">{shot.caption}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
